'use client'

import React from 'react'
import { LinkButton } from '@/components/ui/LinkButton'
import { Text } from '@/components/ui/text'
import { Heading } from '@/components/ui/heading'

export default function Error({ error }: { error: Error }) {
  console.error(error)
  return (
    <div className="container mx-auto py-28 bg-olive-2">
      <div className="text-light flex flex-col items-center justify-center">
        <Heading size="h1">500</Heading>
        <Text className="mb-4">Uh oh! An error occurred.</Text>
        <LinkButton href="/" variant="punch">
          Go home
        </LinkButton>
      </div>
    </div>
  )
}
